import { ProductMapper } from "@omni/mappers/product/product.mapper";
import { SearchResultProductTileConfig } from "@omni/types/components/props/searchResults.props";
import { ProductTileLayout } from "@omni/ui/brand/product/productTile/productTile.config";
import { isDefined } from "@omni/utils/helper.utils";

import { ProductSearchTileRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import { useSearchHitContext } from "@/components/Search/SearchResults/components/results/components/resultList/context/searchHit.context";
import { ResultListHitComponentProps } from "@/components/Search/SearchResults/components/results/components/resultList/resultList.container";
import { useSearchResultsContext } from "@/components/Search/SearchResults/context/searchResults.context";
import * as AlgoliaTrackingService from "@/services/algolia/algoliaTracking.service";
import { ProductAlgoliaModel } from "@/types/service/product/algolia/product.algolia.model";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type ProductHitComponentProps =
    ResultListHitComponentProps<ProductAlgoliaModel> & {
        productTileConfig?: SearchResultProductTileConfig;
    };

const _ProductHitComponent = ({ hit }: ProductHitComponentProps) => {
    const { productTileConfig } = useSearchResultsContext();
    const product = ProductMapper.fromBffSearchToProductTile(hit);

    const { breakpoints } = useBreakpoint();
    const isMobile = !breakpoints.sm;

    const { queryID, position } = useSearchHitContext();

    const categoryLink = !!productTileConfig?.showCategoryLink;
    const button = !productTileConfig || productTileConfig?.showButton;

    const productTileComponents = (
        isMobile ? ProductTileLayout.PLP_HORIZONTAL : ProductTileLayout.PLP
    )(button, categoryLink, true);

    return (
        <ProductTile
            sku={product.sku}
            product={product}
            lazyLoadImage={productTileConfig?.lazyLoad || true}
            allowInstantAddToCart={
                productTileConfig?.allowInstantAddToCart || true
            }
            onClickTrack={() => {
                if (isDefined(queryID) && isDefined(position)) {
                    AlgoliaTrackingService.trackQuery(
                        queryID,
                        hit.sku,
                        position
                    );
                }
            }}
            productTileConfig={{
                border: productTileConfig?.useInsidePadding || true,
                imageRenditions: ProductSearchTileRenditions,
                amountOfFeatures: productTileConfig?.amountOfFeatures ?? 4,
                hoverEffect: true,
                components: productTileComponents,
                ...(isMobile && { columnFractions: [5, 7] })
            }}
            analyticsContext={{
                list: "product-search-results",
                placement: position
            }}
            realtimeStockPromise={hit.realtimeStockPromise}
        />
    );
};

export const ProductHitComponent = withBreakpoints(_ProductHitComponent);
